import * as core from "@zod/core";
import { ZodError } from "./errors.js";
export const parse = /* @__PURE__ */ core._parse.bind({ Error: ZodError });
export const safeParse = /* @__PURE__ */ core._safeParse.bind({ Error: ZodError });
export const parseAsync = /* @__PURE__ */ core._parseAsync.bind({ Error: ZodError });
export const safeParseAsync = /* @__PURE__ */ core._safeParseAsync.bind({
    Error: ZodError,
});
